import React from 'react';
import styles from "./Automobile.css";
import SaraChen from "../../Images/Sara Chen.jpg";
import Marcus from "../../Images/Marcus.jpg";
import Emily from "../../Images/Emily.jpg";
import { useState } from "react";



const App = () => {

  // 👉 STEP 3: FAQ DATA (YAHAN)
  const faqs = [
    {
      q: "How does the AI automation actually work?",
      a: "Our AI engine analyzes your historical sales data, customer interactions, and industry patterns..."
    },
    {
      q: "Can I integrate Toxbox with my existing CRM?",
      a: "Yes. Toxbox integrates with Salesforce, HubSpot, Zoho..."
    },
    {
      q: "What kind of results can I expect?",
      a: "Teams typically see 40%+ more closed deals..."
    },
    {
     q: "Is my data secure?",
     a: "Yes, we use enterprise-grade encryption, secure cloud infrastructure, and strict access controls to ensure your data is always protected."
   },
   {
    q: "What happens after the 14-day trial?",
    a: "After the 14-day trial ends, you can choose a plan that fits your needs and continue using all features without interruption. If you decide not to subscribe, your account will be paused with no charges applied."
  },
  {
    q: "Do you offer training and support?",
    a: "Yes. We provide onboarding sessions, detailed documentation, and ongoing customer support to help your team get the most out of the platform."
  },
  
  ];

  // 👉 STEP 2: STATE + FUNCTION (YAHAN)
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

   return (

    <div className="app">
      {/* === HERO SECTION (UNCHANGED) === */}
      <div className="hero-section">
        {/* Top badge */}
        <div className="badge">
          <span className="badge-icon">✨</span>
          AI-Powered Sales Excellence
        </div>

        {/* Main headline */}
        <h1 className="headline">
          Accelerate Sales
          <br />
          <span className="highlight">Excellence, Automate</span>
          <br />
          <span className="today-gradient">Today</span>
        </h1>

        {/* Subheading */}
        <p className="subheading">
          Transform your sales process with cutting-edge AI automation.{' '}
          <span className="highlight-text">Close deals 3x faster</span>, engage prospects intelligently, and{' '}
          <span className="highlight-text">boost revenue by 250%</span>.
        </p>

        {/* CTA Buttons */}
        <div className="cta-container">
          <button className="btn-primary">
            Start Free Trial →
          </button>
          <button className="btn-outline">
            Watch Demo
            <span className="icon">⚡</span>
          </button>
        </div>

        {/* Footer notes */}
        <div className="footnotes">
          <span className="note">
            <span className="dot green"></span> No Credit Card Required
          </span>
          <span className="note">
            <span className="dot purple"></span> 14-Day Free Trial
          </span>
          <span className="note">
            <span className="dot blue"></span> Cancel Anytime
          </span>
        </div>
      </div>

      {/* === POWERFUL FEATURES SECTION (NEW) === */}
      <div className="features-section">
        <div className="section-badge">
          <span className="badge-icon">⚡</span>
          Powerful Features
        </div>

        <h2 className="features-title">
          Everything You Need<br />
          To Dominate Sales
        </h2>

        <p className="features-subtitle">
          Built for modern sales teams who refuse to settle for average results
        </p>

        {/* Feature Grid - 2 rows × 3 columns */}
        <div className="features-grid">
          {/* Row 1 */}
          <div className="feature-card">
            <div className="icon-wrapper bg-gradient-purple-pink">
              <span className="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="42" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-brain-icon lucide-brain"><path d="M12 18V5"/><path d="M15 13a4.17 4.17 0 0 1-3-4 4.17 4.17 0 0 1-3 4"/><path d="M17.598 6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5"/><path d="M17.997 5.125a4 4 0 0 1 2.526 5.77"/><path d="M18 18a4 4 0 0 0 2-7.464"/><path d="M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517"/><path d="M6 18a4 4 0 0 1-2-7.464"/><path d="M6.003 5.125a4 4 0 0 0-2.526 5.77"/></svg> 
              </span>
            </div>
            <h3 className="feature-title">AI-Powered Intelligence</h3>
            <p className="feature-desc">
              Leverage advanced machine learning to predict customer behavior, optimize outreach timing, and personalize every interaction at scale.
            </p>
          </div>

          <div className="feature-card">
            <div className="icon-wrapper bg-gradient-pink-blue">
              <span className="icon">⚡</span>
            </div>
            <h3 className="feature-title">Lightning Fast Automation</h3>
            <p className="feature-desc">
              Automate repetitive tasks, follow-ups, and data entry. Focus on what matters — building relationships and closing deals.
            </p>
          </div>

          <div className="feature-card">
            <div className="icon-wrapper bg-gradient-blue-purple">
              <span className="icon"><svg xmlns="http://www.w3.org/2000/svg" width="42" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-message-square-icon lucide-message-square"><path d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z"/></svg></span>
            </div>
            <h3 className="feature-title">Smart Engagement</h3>
            <p className="feature-desc">
              AI-driven conversation intelligence analyzes calls and emails to provide real-time coaching and sentiment analysis.
            </p>
          </div>

          {/* Row 2 */}
          <div className="feature-card">
            <div className="icon-wrapper bg-gradient-blue-purple">
              <span className="icon"><svg xmlns="http://www.w3.org/2000/svg" width="42" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chart-column-icon lucide-chart-column"><path d="M3 3v16a2 2 0 0 0 2 2h16"/><path d="M18 17V9"/><path d="M13 17V5"/><path d="M8 17v-3"/></svg></span>
            </div>
            <h3 className="feature-title">Predictive Analytics</h3>
            <p className="feature-desc">
              Get accurate sales forecasts, identify at-risk deals, and discover hidden opportunities with advanced analytics.
            </p>
          </div>

          <div className="feature-card">
            <div className="icon-wrapper bg-gradient-blue-purple">
              <span className="icon"><svg xmlns="http://www.w3.org/2000/svg" width="42" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield-icon lucide-shield"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/></svg></span>
            </div>
            <h3 className="feature-title">Enterprise Security</h3>
            <p className="feature-desc">
              Bank-level encryption, SOC 2 compliance, and GDPR ready. Your data is protected with military-grade security.
            </p>
          </div>

          <div className="feature-card">
            <div className="icon-wrapper bg-gradient-purple-pink">
              <span className="icon"><svg xmlns="http://www.w3.org/2000/svg" width="42" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-rocket-icon lucide-rocket"><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/><path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/></svg></span>
            </div>
            <h3 className="feature-title">Seamless Integration</h3>
            <p className="feature-desc">
              Connect with Salesforce, HubSpot, Slack, and 100+ tools. Set up in minutes, not weeks. Zero technical knowledge required.
            </p>
          </div>
        </div>
      </div>

     {/* === AI AGENT SECTION === */}

    <section className="ai-agent-section">
      <div className="ai-agent-container">

        {/* LEFT CONTENT */}
        <div className="ai-agent-left">
          <div className="agent-badge">
            🤖 AI Agent By Toxbox
          </div>

          <h2 className="agent-title">
            Meet Your <span className="purple">AI Sales</span><br />
            <span className="cyan">Assistant</span>
          </h2>

          <p className="agent-description">
            Our advanced AI agent works 24/7 to qualify leads,
            schedule meetings, and nurture relationships.
            It's like having a team of expert SDRs that never sleep.
          </p>

          <ul className="agent-features">
            <li>Intelligent lead scoring and prioritization</li>
            <li>Automated email sequences with A/B testing</li>
            <li>Real-time conversation intelligence</li>
            <li>Predictive deal outcome analysis</li>
            <li>Smart calendar scheduling</li>
            <li>Personalized content recommendations</li>
          </ul>

          <button className="agent-btn">
            Explore AI Features
          </button>
        </div>

        {/* RIGHT VISUAL */}
        <div className="ai-agent-right">
          <span className="badge accuracy">98% Accuracy</span>
          <span className="badge autopilot">Auto-Pilot</span>
          <span className="badge active">24/7 Active</span>

          <div className="bot-wrapper">
            {/* <svg
              className="bot-icon"
              viewBox="0 0 200 200"
              xmlns="http://www.w3.org/2000/svg"
            >
              <defs>
                <linearGradient id="botGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#9b5cff" />
                  <stop offset="100%" stopColor="#2dd4ff" />
                </linearGradient>
              </defs>

              <circle cx="100" cy="100" r="78" fill="url(#botGradient)" />
              <rect x="60" y="70" width="80" height="35" rx="10" fill="#fff" />
              <circle cx="85" cy="115" r="8" fill="#fff" />
              <circle cx="115" cy="115" r="8" fill="#fff" />
              <path
                d="M75 140h50c0 12-12 22-25 22s-25-10-25-22z"
                fill="#fff"
              />
            </svg> */}

            <svg
  className="bot-icon"
  viewBox="0 0 200 200"
  xmlns="http://www.w3.org/2000/svg"
>
  <defs>
    <linearGradient id="botGradient" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stopColor="#9b5cff" />
      <stop offset="100%" stopColor="#2dd4ff" />
    </linearGradient>
  </defs>

  {/* Background Circle – SAME */}
  <circle cx="100" cy="100" r="78" fill="url(#botGradient)" />

  {/* === BOT ICON (Lucide) === */}
  <g
    transform="translate(60 55) scale(3.2)"
    fill="none"
    stroke="#fff"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 8V4H8" />
    <rect x="4" y="8" width="16" height="12" rx="2" />
    <path d="M2 14h2" />
    <path d="M20 14h2" />
    <path d="M15 13v2" />
    <path d="M9 13v2" />
  </g>
</svg>
          </div>
        </div>

      </div>
    </section>

    <section className="pricing-section">
      {/* Top Badge */}
      <div className="pricing-badge">
        👑 Flexible Pricing
      </div>

      {/* Heading */}
      <h2 className="pricing-title">
        Choose Your <span>Growth Plan</span>
      </h2>

      <p className="pricing-subtitle">
        Start free for 14 days. No credit card required. Cancel anytime.
      </p>

      {/* Cards */}
      <div className="pricing-cards">
        {/* Starter */}
        <div className="pricing-card">
          <div className="plan-icon pink">⚡</div>
          <h3>Starter</h3>
          <p className="plan-desc">
            Perfect for solo entrepreneurs and small teams starting their journey
          </p>

          <div className="price">$49<span>/month</span></div>
          <button className="btn-secondary">Start Free Trial</button>

          <ul>
            <li>✔ Up to 1,000 contacts</li>
            <li>✔ AI-powered email sequences</li>
            <li>✔ Basic analytics dashboard</li>
            <li>✔ 5 team members</li>
            <li>✔ Email support</li>
            <li>✔ Mobile app access</li>
          </ul>
        </div>

        {/* Professional */}
        <div className="pricing-card popular">
          <div className="popular-badge">Most Popular</div>

          <div className="plan-icon blue">👑</div>
          <h3>Professional</h3>
          <p className="plan-desc">
            For growing teams ready to scale their sales operations
          </p>

          <div className="price highlight">$149<span>/month</span></div>
          <button className="btn-primary">Start Free Trial</button>

          <ul>
            <li>✔ Up to 10,000 contacts</li>
            <li>✔ Advanced AI automation</li>
            <li>✔ Predictive analytics</li>
            <li>✔ Unlimited team members</li>
            <li>✔ Priority support 24/7</li>
            <li>✔ Custom integrations</li>
            <li>✔ API access</li>
            <li>✔ Advanced reporting</li>
          </ul>
        </div>

        {/* Enterprise */}
        <div className="pricing-card">
          <div className="plan-icon gradient">🚀</div>
          <h3>Enterprise</h3>
          <p className="plan-desc">
            Tailored solutions for large organizations with complex needs
          </p>

          <div className="price custom">Custom</div>
          <button className="btn-secondary">Contact Sales</button>

          <ul>
            <li>✔ Unlimited contacts</li>
            <li>✔ Full AI agent capabilities</li>
            <li>✔ White-label options</li>
            <li>✔ Dedicated account manager</li>
            <li>✔ Custom AI training</li>
            <li>✔ SLA guarantees</li>
            <li>✔ Advanced security</li>
            <li>✔ On-premise deployment</li>
          </ul>
        </div>
      </div>

      {/* Footer */}
      <p className="pricing-footer">
        All plans include free updates, <span>unlimited support</span>, and <span>99.9% uptime</span>
      </p>
    </section>


    <section className="usecases-section">
      <div className="usecases-header">
        <div className="usecases-badge">🧩 Use Cases</div>

        <h2 className="usecases-title">
          Built For <span>Every</span>
          <br /> Industry
        </h2>

        <p className="usecases-subtitle">
          Trusted by 10,000+ companies across multiple industries
        </p>
      </div>

      <div className="usecases-grid">
        {/* Card 1 */}
        <div className="usecase-card">
          <div className="icon pink">
            <svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
  fill="none"
  stroke="white"
  strokeWidth="3"
  strokeLinecap="round"
  strokeLinejoin="round"
  width="42"
  height="36"
>
  <path d="M10 12h4" />
  <path d="M10 8h4" />
  <path d="M14 21v-3a2 2 0 0 0-4 0v3" />
  <path d="M6 10H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2" />
  <path d="M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16" />
</svg>

          </div>
          <h3>B2B SaaS Companies</h3>
          <p>
            Streamline your entire sales funnel from lead gen to close. Perfect
            for scaling teams.
          </p>
          <span className="pill pink">450% ROI increase</span>
        </div>

        {/* Card 2 */}
        <div className="usecase-card">
          <div className="icon cyan">
            <svg viewBox="0 0 24 24" fill="none">
              <circle cx="9" cy="20" r="1.5" fill="white"/>
              <circle cx="17" cy="20" r="1.5" fill="white"/>
              <path d="M3 4h2l2.4 10.4a2 2 0 0 0 2 1.6h7.6a2 2 0 0 0 2-1.6L21 8H7"
                stroke="white" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </div>
          <h3>E-commerce & Retail</h3>
          <p>
            Convert browsers into buyers with intelligent product
            recommendations and cart recovery.
          </p>
          <span className="pill cyan">3× conversion rate</span>
        </div>

        {/* Card 3 */}
        <div className="usecase-card">
          <div className="icon blue">
            <svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
  fill="none"
  stroke="white"
  strokeWidth="3"
  strokeLinecap="round"
  strokeLinejoin="round"
  width="42"
  height="36"
>
  <path d="M16 7h6v6" />
  <path d="m22 7-8.5 8.5-5-5L2 17" />
</svg>

          </div>
          <h3>Real Estate & Finance</h3>
          <p>
            Nurture high-value leads with personalized follow-ups and automated
            qualification.
          </p>
          <span className="pill blue">60% faster closings</span>
        </div>

        {/* Card 4 */}
        <div className="usecase-card">
          <div className="icon purple">
            <svg viewBox="0 0 24 24" fill="none">
              <rect x="3" y="7" width="18" height="13" rx="2" stroke="white" strokeWidth="2"/>
              <path d="M9 7V5a3 3 0 0 1 6 0v2" stroke="white" strokeWidth="2"/>
            </svg>
          </div>
          <h3>Professional Services</h3>
          <p>
            Win more clients with smart proposal automation and engagement
            tracking.
          </p>
          <span className="pill purple">85% win rate</span>
        </div>
      </div>
    </section>



    <section className="client-testimonials-section">
      {/* Header */}
      <div className="testimonials-header">
        <span className="badge">
          <span className="badge-icon">⭐</span>
          Client Success Stories
        </span>
        <br/>
        <br/>
        <h1 className="headline">
          Loved By <span className="highlight-pink">Sales</span> <span className="highlight-cyan">Leaders</span>
        </h1>
        <p className="subheading">
          Join thousands of high-performing teams crushing their quotas
        </p>
      </div>

      {/* Testimonial Cards */}
      <div className="testimonials-grid">
        <div className="testimonial-card">
          <div className="stars">★★★★★</div>
          <div className="quote-icon">”</div>
          <p className="quote">
            "Toxbox transformed our sales process completely. We closed 40% more deals in the first quarter alone. The AI automation is a game-changer."
          </p>
          <div className="author">
              <img src={SaraChen} alt="Sara Chen" className="avatar" />
            <div> 
              <div className="name">Sarah Chen</div>
              <div className="title">VP of Sales</div>
              <div className="company">TechVentures Inc</div>
            </div>
          </div>
        </div>

        <div className="testimonial-card">
          <div className="stars">★★★★★</div>
          <div className="quote-icon">”</div>
          <p className="quote">
            "Best investment we've made. The predictive analytics helped us focus on high-value leads. Our conversion rate tripled within 60 days."
          </p>
          <div className="author">
             <img src={Marcus} alt="Marcus" className="avatar" />
              <div>
              <div className="name">Marcus Rodriguez</div>
              <div className="title">Founder & CEO</div>
              <div className="company">GrowthLabs</div>
            </div>
          </div>
        </div>

        <div className="testimonial-card">
          <div className="stars">★★★★★</div>
          <div className="quote-icon">”</div>
          <p className="quote">
            "The AI assistant handles all our repetitive tasks. My team now spends 80% more time actually talking to prospects. Revenue is up 250%."
          </p>
          <div className="author">
          <img src={Emily} alt="Emily" className="avatar" />
            <div>
              <div className="name">Emily Watson</div>
              <div className="title">Sales Director</div>
              <div className="company">CloudScale Solutions</div>
            </div>
          </div>
        </div>
      </div>

      {/* Stats Row */}
      <div className="stats-row">
        <div className="stat-item">
          <div className="stat-value highlight-pink">4.9/5</div>
          <div className="stat-label">Average Rating</div>
        </div>
        <div className="stat-item">
          <div className="stat-value highlight-purple">10K+</div>
          <div className="stat-label">Happy Customers</div>
        </div>
        <div className="stat-item">
          <div className="stat-value highlight-cyan">98%</div>
          <div className="stat-label">Retention Rate</div>
        </div>
        <div className="stat-item">
          <div className="stat-value highlight-blue">24/7</div>
          <div className="stat-label">Expert Support</div>
        </div>
      </div>
    </section>


{/* === FAQ SECTION (REWRITTEN TO MATCH DESIGN) === */}
<section className="faq-section">
  <div className="faq-header">
    <span className="badge">
      <span className="badge-icon">❓</span>
      FAQ
    </span>
    <h1 className="headline">
      Still Have <span className="highlight-purple">Questions</span>
      <span className="highlight-cyan">?</span>
    </h1>
    <p className="subheading">Everything you need to know about Toxbox</p>
  </div>

  <div className="faq-accordion">
    {faqs.map((faq, index) => (
      <div
        key={index}
        className={`faq-item ${openIndex === index ? 'open' : ''}`}
      >
        {/* Question Row */}
        <button
          className="faq-question"
          onClick={() => toggleFAQ(index)}
          aria-expanded={openIndex === index}
        >
          <span className="question-text">{faq.q}</span>
          <span className="toggle-icon">
            {openIndex === index ? (
              <svg viewBox="0 0 24 24" width="24" height="24" fill="none">
                <circle cx="12" cy="12" r="12" fill="url(#gradient)" />
                <path d="M7 12h10" stroke="white" strokeWidth="2" strokeLinecap="round" />
              </svg>
            ) : (
              <svg viewBox="0 0 24 24" width="24" height="24" fill="none">
                <circle cx="12" cy="12" r="12" fill="url(#gradient)" />
                <path d="M7 12h10M12 7v10" stroke="white" strokeWidth="2" strokeLinecap="round" />
              </svg>
            )}
          </span>
        </button>

        {/* Answer Content */}
        {/* Answer Content */}
<div
  className="faq-answer"
  style={{
    maxHeight: openIndex === index ? '1000px' : '0',
    opacity: openIndex === index ? 1 : 0,
    overflow: 'hidden',
    transition: 'max-height 0.4s ease-in-out, opacity 0.4s ease',
    paddingTop: openIndex === index ? '16px' : '0',
    paddingBottom: openIndex === index ? '20px' : '0'
  }}
>
  <div className="answer-content">{faq.a}</div>
</div>
      </div>
    ))}
  </div>

  <div className="faq-footer">
    <p className="help-text">Can't find what you're looking for?</p>
    <a href="#support" className="contact-link">
      Contact our support team →
    </a>
  </div>
</section>


    <section className="trial-section" aria-labelledby="trial-heading">
      {/* Primary CTA (top) */}
      <button
        className="cta-primary"
        aria-label="Start your free trial today"
        onClick={() => console.log('Trial started!')}
      >
        <span className="sparkle">✨</span>
        Start Your Free Trial Today
      </button>

      {/* Main Headline */}
      <h2 id="trial-heading" className="headline">
        Ready to{' '}
        <span className="gradient-text">
          10x Your Sales?
        </span>
      </h2>

      {/* Subheading */}
      <p className="subheading">
        Join 10,000+ companies already crushing their quotas with AI-powered automation. 
        No credit card required. Setup in under 5 minutes.
      </p>

      {/* Secondary CTAs (stacked on mobile, inline on desktop) */}
      <div className="cta-secondary-group">
        <button
          className="cta-secondary"
          aria-label="Start free trial"
        >
          Start Free Trial →
        </button>
        <button
          className="cta-secondary cta-outline"
          aria-label="Learn more"
        >
          Learn More
        </button>
      </div>

      {/* Trust badges */}
      <ul className="trust-badges" aria-hidden="true">
        <li><span className="dot dot-green"></span> 14-Day Free Trial</li>
        <li><span className="dot dot-purple"></span> No Credit Card</li>
        <li><span className="dot dot-cyan"></span> Cancel Anytime</li>
      </ul>
    </section>

    </div>
  );
};

export default App;